import { LAYER_TYPES, LAYER_SUBTYPES } from '../../../../api/Layers/Layers';

const OPENSTREETMAP_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

export default [
  {
    name: 'OpenStreetMap.Mapnik',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.TILE_SERVER,
    description: '',
    imageUrl: 'https://srmconsulting.es/Imaps/static/media/29__.png',
    attribution: OPENSTREETMAP_ATTRIBUTION,
    styleId: 'TILE STYLE'
  },
  {
    name: 'OpenTopoMap',
    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.TILE_SERVER,
    description: '',
    attribution: `Map data: ${OPENSTREETMAP_ATTRIBUTION}, <a href="https://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)`,
    styleId: 'TILE STYLE'
  },
  {
    name: 'Hydda.Base',
    url: 'https://{s}.tile.openstreetmap.se/hydda/base/{z}/{x}/{y}.png',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.TILE_SERVER,
    description: '',
    attribution: `Tiles courtesy of <a href="https://openstreetmap.se/" target="_blank">OpenStreetMap Sweden</a> &mdash; Map data ${OPENSTREETMAP_ATTRIBUTION}`,
    styleId: 'TILE STYLE'
  },
  {
    name: 'Stamen.TonerLite',
    url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}.png',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.TILE_SERVER,
    description: '',
    attribution: `Map tiles by <a href="https://stamen.com">Stamen Design</a>, <a href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data ${OPENSTREETMAP_ATTRIBUTION}`,
    subdomains: 'abcd',
    styleId: 'TILE STYLE'
  },
  {
    name: 'Stamen.Watercolor',
    url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.png',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.TILE_SERVER,
    description: '',
    attribution: `Map tiles by <a href="https://stamen.com">Stamen Design</a>, <a href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data ${OPENSTREETMAP_ATTRIBUTION}`,
    subdomains: 'abcd',
    styleId: 'TILE STYLE'
  },
  {
    name: 'Esri.WorldStreetMap',
    url:
      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.TILE_SERVER,
    description: '',
    attribution:
      'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012',
    subdomains: 'abcd',
    styleId: 'TILE STYLE'
  },
  {
    name: 'Esri.Imagery',
    url:
      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.TILE_SERVER,
    description: '',
    attribution:
      'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    subdomains: 'abcd',
    styleId: 'TILE STYLE'
  },
  {
    name: 'Stamen.Watercolor Low Opacity',
    url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.png',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.TILE_SERVER,
    description: '',
    attribution: `Map tiles by <a href="https://stamen.com">Stamen Design</a>, <a href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data ${OPENSTREETMAP_ATTRIBUTION}`,
    subdomains: 'abcd',
    styleId: 'TILE STYLE'
  }
];
